export const claimMotion = {
  duration: { micro: 0.16, interface: 0.22, step: 0.28 },
  distance: { feedback: 4, exit: 12, enter: 18 },
  ease: { standard: [0.2, 0, 0, 1] as const },
} as const;

export function claimStepVariants(direction: -1 | 1, reduced: boolean) {
  if (reduced) {
    const visible = { opacity: 1, x: 0 } as const;
    return { enter: visible, center: visible, exit: visible };
  }
  return {
    enter: { opacity: 0, x: direction * claimMotion.distance.enter },
    center: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: direction * -claimMotion.distance.exit },
  };
}
